import styled from 'react-emotion';

export const VideoContainer = styled('video')({
  width: '100%',
  borderRadius: 20,
  backgroundColor: 'black',
});
